import useFeatureFlags from "utilities/hooks/use-feature-flags";
import MemoriesService from "utilities/services/memories/memories-service";
export const MAX_MEMORIES_PER_USER = 10;
const useMemories = () => {
    const { list: listMemoriesApi } = MemoriesService.useListQuery();
    const { allowCasiMemories } = useFeatureFlags();

    const {
        data: memories,
        isLoading: isLoadingMemories,
        isFetching: isFetchingMemories,
        refetch,
    } = listMemoriesApi(
        {},
        { keepPreviousData: true, enabled: allowCasiMemories }
    );

    return {
        memories,
        isLoadingMemories: isLoadingMemories || isFetchingMemories,
        refetch,
    };
};

export default useMemories;
